// Єнотик ZNOHUB — брендові рендери. Відсутність зображення не блокує урок (ANI-05): є текстовий fallback.
import { useState } from 'react';
export type Pose = 'point' | 'think' | 'proud' | 'head';
const ALT: Record<Pose, string> = {
  point: 'Єнотик ZNOHUB показує пальцями', think: 'Єнотик ZNOHUB замислився',
  proud: 'Єнотик ZNOHUB схрестив руки й усміхається', head: 'Єнотик ZNOHUB',
};
export function Mascot({ pose, className = '', float = false, enter = false }: { pose: Pose; className?: string; float?: boolean; enter?: boolean }) {
  const [failed, setFailed] = useState(false);
  if (failed) return <span role="img" aria-label={ALT[pose]} className={`grid place-items-center text-5xl ${className}`}>🦝</span>;
  return (
    <img src={`/mascot/raccoon-${pose}.webp`} alt={ALT[pose]} draggable={false} onError={() => setFailed(true)}
      className={`mascot ${float ? 'mascot-float' : ''} ${enter ? 'mascot-in' : ''} ${className}`} />
  );
}
